import { PlayRoundedIcon } from '@/assets/icons';
import CatalyzingConceptLogo from '@/assets/images/CatalyzingConceptLogo.png';
import { AuthSelector } from '@/store/auth';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SignupProcess, SuccessMetrics } from './subComponents';
const btnSx = {
    height: '50px',
    fontWeight: 500,
    fontSize: '1rem',
    borderRadius: '8px',
    textTransform: 'none',
};
export const GetStarted = () => {
    const navigate = useNavigate();
    //const dispatch = useDispatch<AppDispatch>()
    const loading = useSelector(AuthSelector.getLoading);
    const handleCreateSession = async () => {
        navigate('/salesWizard');
        //const result = await dispatch(AuthActions.createSessionAsync())
        //if (AuthActions.createSessionAsync.fulfilled.match(result)) {
        //}
    };
    return (React.createElement(Box, { sx: {
            px: 3,
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        } },
        React.createElement(Stack, { mt: { xs: 8, md: 10 }, position: "relative", zIndex: 1, gap: 1, alignItems: "center" },
            React.createElement("img", { src: CatalyzingConceptLogo, alt: "Catalyzing Concept", style: { width: '300px', marginBottom: '20px' } }),
            React.createElement(Typography, { textAlign: "center", color: "secondary", fontWeight: 700, fontSize: { xs: '1.5rem', md: '2rem' } }, "Let\u2019s help your concept take off!"),
            React.createElement(Typography, { textAlign: "center", color: "secondary.light", fontSize: "1rem", fontWeight: 500, sx: { maxWidth: '700px' } }, "Welcome to Catalyzing Concepts! Thank you for trying out our newest product, GrantMatch. In the next five minutes we will provide you a list of relevant funding opportunity for your project or organization."),
            React.createElement(Stack, { mt: 4, direction: "row", gap: 2 },
                React.createElement(Button, { disableElevation: true, variant: "outlined", color: "secondary", startIcon: React.createElement(PlayRoundedIcon, null), sx: {
                        ...btnSx,
                        borderColor: (theme) => theme.palette.grey[200],
                    }, onClick: () => window.open('https://www.loom.com/share/7bbc8cbf35e34149bca91ca7d87494c9?sid=4f68bec3-3908-42ca-85d6-94dd51018093') }, "Watch video"),
                React.createElement(Button, { sx: btnSx, disableElevation: true, loading: loading, variant: "contained", loadingPosition: "center", endIcon: React.createElement(ArrowForwardRounded, null), onClick: handleCreateSession }, "Get started")),
            React.createElement(SuccessMetrics, null),
            React.createElement(SignupProcess, null))));
};
